import React, {useState} from 'react';
import { InfoBox, OtherCard } from 'components';
import Checklist from 'assests/icons/checklist.icon';

import {  Button,Modal } from 'antd';

import { useHistory } from 'react-router-dom';
const IysCard = () =>
{
  const [isyBrandInfoModal, setIsyBrandInfoModal] = useState(false);
  var history=useHistory();
  return (
    <React.Fragment>
      <OtherCard
        v2
        content={<>
          <span className="other-card__title">İYS Kapsamı</span>
          <p>İYS Kapsamında gönderimlere devam etmek için lütfen İYS numaralarınızı mesaj başlıklarına tanımlayınız.</p>
          <div className="other-card__buttons">
            <Button type="ghost" shape="round" onClick={() => setIsyBrandInfoModal(true)}>
            İYS Kapsamı Nedir?
            </Button>

            <Button
              type="primary"
              shape="round"
              onClick={(e) => history.push("/Title")}
            >
              Tanımsız Mesajları Gör
            </Button>
          </div>
        </>}
        actions={
        <>
          <Checklist />
        </>
        }
      />
      <Modal
        title="İYS Marka Bilgisi"
        visible={isyBrandInfoModal}
        onCancel={() => setIsyBrandInfoModal(false)}
        footer={[
          <div className="modal-action">
            <Button
              key="confirm"
              shape="round"
              type="ghost"
              onClick={() =>
              {
                setIsyBrandInfoModal(false)
              }}
            >
              Tamam
            </Button>
          </div>
        ]}>
        <InfoBox content={
          <>
            <p>	
              <p><b>İYS Nedir?</b></p>
              <br />

              Hizmet Sağlayıcılar'ın arama, mesaj ve e-posta gibi farklı tipte ileti izinlerini saklayıp yönetebilecekleri, İleti Yönetim Sistemidir.<br />
              <br />


              İleti Yönetim Sistemi'ne nasıl başvurabilirim?<br />
              <br />
              Sistemi kullanmak için İleti Yönetim Sistemi başvuru formunu kullanarak gerekli bilgi ve belgeleri iletmeniz gerekmektedir. Başvuru aşamasında girmiş olduğunuz bilgi ve belgeler kontrol edilip doğrulandıktan sonra hesabınız kullanıma açılır.
              <br /><br />
              Başvuru oluşturmak için <a rel="noopener noreferrer" href="https://iys.org.tr/hizmet-saglayici/basvuru/nasil-yapilir" target="_blank">https://iys.org.tr/hizmet-saglayici/basvuru/nasil-yapilir</a>
              <br /><br />

              İYS’ye kayıt olduktan sonra, 15 Temmuz 2021’de devreye giren Ticari İletişim ve Ticari Elektronik İletiler Yönetmeliği kapsamında  
              Ticari İletişim Mesajları  gönderimlerinizde sorun yaşamamak için  
              «İleti Yönetim Sistemi’ne giriş yaparak «Marka Yönetimi» 
              alanından «AHS Ekle» butonuna tıklayarak Turkcell’e izin vermeniz yeterlidir. 
              İYS girişi için <a rel="noopener noreferrer" href="https://hs.iys.org.tr/giris/?redirect=%2F#login_required" target="_blank">buraya</a> tıklayınız.
              <br /><br />
              Daha detaylı bilgi almak için <a rel="noopener noreferrer" href="https://iys.org.tr/iys/sss" target="_blank">https://iys.org.tr/iys/sss</a> sayfasındaki soru ve cevapları inceleyebilirsiniz.
            </p>
          </>
        }
        />
      </Modal>
    </React.Fragment>
  );
};

export default IysCard;
